import { AnnouncementsItemType } from "../../../../mp-database/contextHelpManager"
import { TEACHER_FEEDBACK_ID } from "../../../../mp-core/components/FeedbackTray/constants"
import { AudienceLocation } from "../../../../user-management/pages/ContextHelpManager/EditAnnouncementsModal/constants"

export const tipsTypes = [
  "WHATS_NEW",
  "GENERAL",
  "TIP",
  "CUSTOM",
  "FEEDBACK_REQUEST"
]

export const PAGE_MODULE_MAP = {
  truscore: {
    "practice-tests": AudienceLocation.TruscorePracticeTests,
    bubblesheets: AudienceLocation.BubbleSheet,
    "study-hall": AudienceLocation.StudyHall
  },
  mastery: AudienceLocation.Mastery,
  snap: {
    elements: AudienceLocation.Elements,
    reports: AudienceLocation.SnapCourse
  },
  manage: {
    organization: {
      organization: AudienceLocation.ManageOrganization,
      districts: AudienceLocation.ManageDistricts,
      "district-admins": AudienceLocation.ManageDistrictAdmins,
      schools: AudienceLocation.ManageSchools,
      "school-admins": AudienceLocation.ManageSchoolAdmins,
      teachers: AudienceLocation.ManageTeachers,
      classes: AudienceLocation.ManageClasses,
      students: AudienceLocation.ManageStudents
    }
  },
  eoc: {
    eoc: AudienceLocation.StudyPlan,
    dashboard: AudienceLocation.StudyPlanHome,
    "study-plans": AudienceLocation.StudyPlanStudyPlans,
    insights: AudienceLocation.StudyPlanInsights
  },
  reporting: {
    reporting: AudienceLocation.Reporting,
    insights: AudienceLocation.ReportingInsights,
    content: AudienceLocation.ReportingContent,
    organization: AudienceLocation.ReportingOrganization,
    "teaching-tools": {
      "teaching-tools": AudienceLocation.ReportingTeachingTools,
      "study-plan": AudienceLocation.ReportingTeachingToolsStudyPlan,
      "bell-ringers": AudienceLocation.ReportingTeachingToolsBellRingers,
      "test-administration":
        AudienceLocation.ReportingTeachingToolsTestAdministration,
      "mastery-curriculum":
        AudienceLocation.ReportingTeachingToolsMasteryCurriculum,
      "skill-review": AudienceLocation.ReportingTeachingToolsSkillReview,
      books: AudienceLocation.ReportingTeachingToolsBooks
    }
  },
  "context-help-manager": AudienceLocation.ContextHelpManager,
  ebooks: AudienceLocation.EBooks,
  login: AudienceLocation.Login
}

export type AnnouncementStylesData = {
  icon: React.ReactElement
  colors: AnnouncementColors
}

export type AnnouncementColors = {
  mainColor: string
  lightColor: string
}

export const isAnnouncementWithLocations = (
  item: AnnouncementsItemType,
  page: string,
  module: string,
  subpage?: string
) => {
  // Nested map structure allows to preserve compatibility with old locations.
  const location =
    PAGE_MODULE_MAP[page]?.[module]?.[subpage] ??
    PAGE_MODULE_MAP[page]?.[module]?.[module] ??
    PAGE_MODULE_MAP[page]?.[module] ??
    PAGE_MODULE_MAP[page]?.[page] ??
    PAGE_MODULE_MAP[page]
  // If no locations -> announcement will be on every locations
  return item?.locations?.length > 0 ? item.locations?.includes(location) : true
}

export const isAnnouncementWithPrograms = (
  item: AnnouncementsItemType,
  program: string
) => {
  // If no programs -> announcement will be with every programs
  return program && item?.programs?.length > 0
    ? item.programs?.includes(program?.toUpperCase())
    : true
}

export const SEPARATED_GHOSTIE_CARD_IDS = [TEACHER_FEEDBACK_ID]
